import { useMutation } from '@apollo/client';
import { CREATE_LEARNING_OBJECT_MUTATION } from '../../mutations';

export function useCreateLearningObjectMutation() {
    return useMutation( CREATE_LEARNING_OBJECT_MUTATION );
}
